import {createFileRoute, redirect} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {isWorkspaceRootPath, throwRedirectToWorkspaceConfigEntry} from "~/utilities/workspaceHomeRoute";
import {CONFIG_PAGE_ROUTE_TO} from "~/workspaceConfig/configPageRoutes";
import {resolveReservedConfigPageRedirect} from "~/workspaceConfig/configPageIds";
import {hasWorkspaceUiConfig} from "~/workspaceConfig/configRuntime";
import {notFoundIfWorkspaceConfigPresent} from "~/workspaceConfig/notFoundIfWorkspaceConfigPresent";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_defaultScaffold")({
    beforeLoad: ({context, location}) => {
        const workspaceId = context.workspace.id;
        if (hasWorkspaceUiConfig(workspaceId) === true && isWorkspaceRootPath(location.pathname, workspaceId) === true) {
            throwRedirectToWorkspaceConfigEntry(workspaceId, context.currentWorkspaceUser.templateId);
        }
        if (hasWorkspaceUiConfig(workspaceId) === true) {
            const reservedRedirect = resolveReservedConfigPageRedirect({
                pathname: location.pathname,
                workspaceId: workspaceId,
                userTemplateId: context.currentWorkspaceUser.templateId,
            });
            if (reservedRedirect !== null) {
                throw redirect({
                    to: CONFIG_PAGE_ROUTE_TO,
                    params: {
                        workspaceId: workspaceId,
                        pageKey: reservedRedirect.pageKey,
                    },
                    search: {},
                    replace: true,
                });
            }
        }
        const normalizedPath = location.pathname.replace(/\/+$/, "");
        const isStoreConfigurationPath = normalizedPath.endsWith("/store-configuration");
        const isTicketsPath = normalizedPath.endsWith("/tickets");
        const isMarketplaceIntelligencePath = /\/marketplace-intelligence(?:\/|$)/.test(normalizedPath);
        if (isStoreConfigurationPath !== true && isTicketsPath !== true && isMarketplaceIntelligencePath !== true) {
            notFoundIfWorkspaceConfigPresent(workspaceId);
        }
    },
    loader: async ({context}) => {
        return {
            accessibleWorkspaces: context.accessibleWorkspaces,
            workspace: context.workspace,
            environment: context.environment,
            intellsysBaseUrl: context.intellsysBaseUrl,
            accessToken: context.authenticationStatus.accessToken,
            users: context.users,
            subscriptionDetails: context.subscriptionDetails,
            pricingPlanNudgeStatus: context.pricingPlanNudgeStatus,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
